






















































import { Component, Prop, Emit, Mixins } from 'vue-property-decorator';
import SFormElement from './SFormElement.vue';
import SElementValidationErrors from './SElementValidationErrors.vue';

@Component({
  components: {
    SElementValidationErrors,
  },
})
export default class SRadio extends Mixins(SFormElement) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop() private radioValue?: any;
  @Prop(Boolean) private disabled?: boolean;

  private focused = false;

  private get isChecked(): boolean {
    return this.value === this.radioValue;
  }

  private get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  @Emit('input')
  private handleInput() {
    return this.radioValue;
  }
}
